import React from 'react'

const Component3 = () => {
  return (
    <div>Component3</div>
  )
}

export default Component3